export const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

// The complaint "issuedBy.type" values that count as a real, user-facing
// complaint. "internal" and "procedure" are machine-generated and must be
// excluded from every complaint list/count the exec app shows.
export const COMPLAINT_SOURCE_TYPES = ["customerSupport", "public", "independentEngineer"];

// "" is the "no filter" sentinel used by the complaint source/status dropdowns.
export const COMPLAINT_SOURCE_OPTIONS = [
  { key: "", label: "All Sources" },
  { key: "public", label: "Public" },
  { key: "customerSupport", label: "Customer Support" },
  { key: "independentEngineer", label: "Independent Engineer" },
];

// status.currentStatus is stored uppercase — see functions/libs/feature/complaint.js
export const COMPLAINT_STATUS_OPTIONS = [
  { key: "", label: "All Statuses" },
  { key: "OPEN", label: "Open" },
  { key: "UNDER REVIEW", label: "Under Review" },
  { key: "PENDING CLOSURE", label: "Pending Closure" },
  { key: "CLOSED", label: "Closed" },
];
